export const defaultTheme: any = {
  toshiba: {
    color: {
      dark: {
        theme: 'dark',
        layoutBackground: '#471567',
        primaryColor: '#7500c0',
        secondaryColor: '#e6bfff',
        tertiaryColor: '#9b91eb',
        errorColor: '#ff6666',
        warningColor: '#fad860',
        successColor: '#3cb371',
        infoColor: '#6699ff',
      },
      light: {
        theme: 'light',
        layoutBackground: '#ffffff',
        primaryColor: '#E90E21',
        secondaryColor: '#e6bfff',
        tertiaryColor: '#9b91eb',
        errorColor: '#ff6666',
        warningColor: '#fad860',
        successColor: '#3cb371',
        infoColor: '#6699ff',
      },
    },
    configuration: {
      theme: 'light',
      logoUrl: '/assets/accenture_icon.png',
      faviconUrl: '/assets/toshiba.ico',
      pageTitle: null,
      userAvatar: null,
      footerText: 'Accenture ©' + new Date().getFullYear(),
    },
  },
  accenture: {
    color: {
      dark: {
        theme: 'dark',
        layoutBackground: '#471567',
        primaryColor: '#7500c0',
        secondaryColor: '#e6bfff',
        tertiaryColor: '#9b91eb',
        errorColor: '#ff6666',
        warningColor: '#fad860',
        successColor: '#3cb371',
        infoColor: '#6699ff',
      },
      light: {
        theme: 'light',
        layoutBackground: '#ffffff',
        primaryColor: '#7500c0',
        secondaryColor: '#e6bfff',
        tertiaryColor: '#9b91eb',
        errorColor: '#ff6666',
        warningColor: '#fad860',
        successColor: '#3cb371',
        infoColor: '#6699ff',
      },
    },
    configuration: {
      theme: 'light',
      logoUrl: '/assets/accenture_icon.png',
      faviconUrl: '/assets/favicon.ico',
      pageTitle: null,
      userAvatar: null,
      footerText: 'Accenture ©' + new Date().getFullYear(),
    },
  },
  tralit: {
    color: {
      dark: {
        theme: 'dark',
        layoutBackground: '#C00000',
        primaryColor: '#F79494',
        secondaryColor: '#002E72',
        tertiaryColor: '#C4E3F7',
        errorColor: '#C00000',
        warningColor: '#D98B03',
        successColor: '#4D9078',
        infoColor: '#6699ff',
        urgentColor: '#610345',
      },
      light: {
        theme: 'light',
        layoutBackground: '#ffffff',
        primaryColor: '#C00000',
        secondaryColor: '#002E72',
        tertiaryColor: '#828282',
        errorColor: '#C00000',
        warningColor: '#D98B03',
        successColor: '#4D9078',
        infoColor: '#6699ff',
        urgentColor: '#610345',
      },
    },
    configuration: {
      theme: 'light',
      logoUrl: '/assets/EffiMate.png',
      faviconUrl: 'https://www.toyo-eng.com/jp/ja/img/common/logo_sp.png',
      pageTitle: '',
      userAvatar: '',
      footerText: '',
    },
  },
};
